import React from "react";
import { t } from "../../utils/i18n";
import PlaystoreImage from "../../../assets/images/playstore_image.png";
import AppstoreImage from "../../../assets/images/appstore_image.png";
import "../P2PTrades/styles/trademodals.scss";

const DownloadAppModal = () => {
  const closeDownloadAppModal = () => {
    const downloadAppModal = document.querySelector("#downloadAppModal");
    if (downloadAppModal) {
      downloadAppModal.style.display = "none";
      document.body.style.overflow = "auto";
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <div
      className="modal-status-cont"
      id="downloadAppModal"
    >
      <div className="modal-status-alert-cont">
        <button type="button" className="close" onClick={closeDownloadAppModal}>
          <span aria-hidden="true" style={{ fontSize: "2.3rem" }}>×</span>
        </button>
        <br />
        <div className="modal-title">
          <p style={{ textAlign: "center" }}>
            <i className="fas fa-mobile-alt" style={{ fontSize: "2.5rem", color: "#4c3f84" }}></i>
            <br /><br />
            <span style={{ fontSize: "1.7rem", lineHeight: "2rem", color: "#2b2e4e" }}>
              {t("home.download_app.trust_us")} 👍 <br/>{t("home.download_app.better_on_app")}
            </span>
          </p>
        </div>
        <div className="downloadAppModal-notice">
          <p style={{ fontSize: "1rem", textAlign: "center" }}>
            {t("home.download_app.smoother")}<br/>
            <b>{t("home.download_app.lets_go")} 😎 </b>
          </p>
        </div>
        <br />
        <div className="modal-buttons-section">
          <a href="https://play.google.com/store/apps/details?id=com.bananacrystal.BananaCrystal&pli=1" target="_blank" rel="noopener noreferrer">
            <img src={PlaystoreImage} alt="google-play" />
          </a>
          <a href="https://apps.apple.com/tr/app/banana-crystal/id6449340769" target="_blank" rel="noopener noreferrer">
            <img src={AppstoreImage} alt="ios-play" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default DownloadAppModal;
